import { useQuery } from 'react-query';
import { network } from 'services/network';

const getLargestFloatChangesTableData = (params) => {
    const payload = {
        compareVersionId: params.compareVersionId,
        contractId: params.contractId,
        latestVersionId: params.latestVersionId,
        projectId: params.projectId,
        filter: params.filterData,
    };
    return network
        .post('api/bo/getLargestFloatChanges', payload)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            throw error;
        });
};

export const useQueryLargestFloatChangesTableData = (params) => {
    return useQuery(['largestFloatChangesTableData', params], () => getLargestFloatChangesTableData(params), {
        enabled: Boolean(params.compareVersionId) && Boolean(params.latestVersionId),
    });
};
